import React, { useState } from 'react'
import { Form, Input, Modal, Select, Space, Typography } from 'antd'
import { createWallet } from './model'

type AccessType = 'full' | 'limited'
type AccessEntry = { role: string; accessType: AccessType }

const roles = [
  ['ROLE_FINANCE_MANAGER', 'Finance manager'],
  ['ROLE_SENIOR_FINANCE_MANAGER', 'Senior finance manager'],
  ['ROLE_LEAD_FINANCE_MANAGER', 'Lead finance manager'],
]

type Props = {
  isOpen: boolean
  onClose: () => void
  onCreated: () => void
}
export const CreateWalletModal: React.FC<Props> = ({ isOpen, onClose, onCreated }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [access, setAccess] = useState<AccessEntry[]>([])

  const submit = async () => {
    const values = await form.validateFields()
    setLoading(true)
    try {
      await createWallet({ body: { ...values, access } })
      form.resetFields()
      setAccess([])
      onClose()
      onCreated()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal title="New wallet" open={isOpen} onCancel={onClose} destroyOnHidden
      onOk={submit} confirmLoading={loading} okText="Add wallet">
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input placeholder="Used for payment system and wallet" />
        </Form.Item>
      </Form>
      <Typography.Text strong>Wallet access</Typography.Text>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 8 }}>
        CEO, CFO, CMO and FPO always receive full access.
      </Typography.Paragraph>
      <Space direction="vertical" style={{ width: '100%' }}>
        {roles.map(([role, label]) => {
          const current = access.find((item) => item.role === role)
          return <Space key={role} style={{ width: '100%' }}>
            <Typography.Text style={{ minWidth: 240 }}>{label}</Typography.Text>
            <Select<AccessType | 'none'> value={current?.accessType || 'none'} style={{ minWidth: 180 }}
              options={[{ value: 'none', label: 'No access' }, { value: 'limited', label: 'View in list only' }, { value: 'full', label: 'Full access' }]}
              onChange={(accessType) => setAccess((items) => accessType === 'none'
                ? items.filter((item) => item.role !== role)
                : [...items.filter((item) => item.role !== role), { role, accessType }])} />
          </Space>
        })}
      </Space>
    </Modal>
  )
}
